import { render, staticRenderFns } from "./RecommendationsView.vue?vue&type=template&id=56bb5d08&scoped=true&"
import script from "./RecommendationsView.vue?vue&type=script&lang=js&"
export * from "./RecommendationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bb5d08",
  null
  
)

export default component.exports